//#region src/recommendation_experiment_type.ts
var RecommendationExperimentType = /* @__PURE__ */ function(RecommendationExperimentType) {
	RecommendationExperimentType["None"] = "none";
	RecommendationExperimentType["ItemViewRecommendationLevel"] = "item-view-recommendation-level";
	RecommendationExperimentType["RuleBased"] = "rule-based";
	return RecommendationExperimentType;
}(RecommendationExperimentType || {});
//#endregion
export { RecommendationExperimentType };

//# sourceMappingURL=recommendation_experiment_type.js.map